export const agGridLocaleES = {
    of: "de",
    to: "a",
    page: "Página",
};
